import request from "superagent";

export const API_URL = `${window.location.origin}/api`;
// export const API_URL = "https://secure-client.dev.arteia.xyz/api";

const { Rollbar } = window;

export function getToken() {
  return "no token"; // Auth.getAccessToken()
}

export function getAuthorizationHeader() {
  return `Bearer ${getToken()}`;
}

function getAccountsUrl() {
  switch (window.location.host) {
    case "secure-client.dev.arteia.xyz":
      return "https://accounts.dev.arteia.xyz";
    case "secure-client.preprod.arteia.xyz":
      return "https://accounts.preprod.arteia.xyz";
    case "secure.arteia.com" || "secure-client.prod.arteia.xyz":
      return "https://accounts.arteia.com";
    default:
      return "https://accounts.dev.arteia.xyz";
  }
}

const API = {
  get: (url) =>
    request
      .get(`${API_URL}${url}`)
      .set("Authorization", getAuthorizationHeader())
      .then((res) => res.body)
      .catch((e) => {
        notifyError("GET", url, e);
        throw e;
      }),
  getOrganisations: (token) => {
    const url = `${getAccountsUrl()}/v1/profile`;
    return request
      .get(url)
      .set("x-auth-token", token)
      .then((res) => res.body)
      .catch((e) => {
        notifyError("GET", url, e);
        throw e;
      });
  },
  post: (url, body = {}, opts = {}) => {
    const { passFullRes = false } = opts;
    return request
      .post(`${API_URL}${url}`)
      .set("Accept", "application/json")
      .set("Authorization", getAuthorizationHeader())
      .send(body)
      .then((res) => (passFullRes ? res : res.body))
      .catch((e) => {
        notifyError("POST", url, e);
        throw e;
      });
  },
  put: (url, body = {}) =>
    request
      .put(`${API_URL}${url}`)
      .set("Accept", "application/json")
      .set("Authorization", getAuthorizationHeader())
      .send(body)
      .then((res) => res.body)
      .catch((e) => {
        notifyError("PUT", url, e);
        throw e;
      }),
  patch: (url, body = {}) =>
    request
      .patch(`${API_URL}${url}`)
      .set("Accept", "application/json")
      .set("Authorization", getAuthorizationHeader())
      .send(body)
      .then((res) => res.body)
      .catch((e) => {
        notifyError("PATCH", url, e);
        throw e;
      }),
  delete: (url) =>
    request
      .delete(`${API_URL}${url}`)
      .set("Accept", "application/json")
      .set("Authorization", getAuthorizationHeader())
      .then((res) => res.body)
      .catch((e) => {
        notifyError("DELETE", url, e);
        throw e;
      }),
};

function notifyError(type, url, err) {
  if (err.status === 404) {
    return;
  }
  Rollbar.error(
    `API error at ${window.location.href}: ${type} ${API_URL} ${url}`,
    err
  );
}

export default { ...API, getToken };



// WEBPACK FOOTER //
// ./src/arteia-js/services/Api.js